import React from 'react';
import { Switch, Redirect, Route } from 'react-router-dom';
import PropTypes from 'prop-types'; 

import { RouteWithLayout } from './components'; 
import { Main as MainLayout, Visitor as VisitorLayout, Minimal as MinimalLayout } from './layouts';

import apiManager from './ApiManager';



import { 
  SignUp as SignUpView,
  SignIn as SignInView,
  NotFound as NotFoundView,  
  ResetPassword as ResetView,
  TermsAndConditions as TermsView,
  Impersonate as ImpersonateView,
  Error as ErrorView,
  SignUpVerification,
//   HomeVisitor as HomeVisitor
} from './views';



class VisitorRoutes extends React.PureComponent {
  constructor(props) {
    super(props);
    const { user, appProps  } = this.props;
    this.state = { 
      user: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : (user ? user : {}),
      apiManager,
      appProps,
    }; 
    this.updateUser = this.updateUser.bind(this);    
    
  }


 
  componentDidUpdate() {
    const { user } = this.state;
    const { history } = this.props;
    if(!user || !user.userName && history){
      history.push('/signin');
    }
  }

  updateUser(user) {
    user.initials = `${user.firstname.toUpperCase().charAt(0)}${user.lastname.toUpperCase().charAt(0)}`;
    this.setState({ user })
    localStorage.setItem('user', JSON.stringify(user));
 
  }
  render() {
    const { user, apiManager, history, appProps } = this.state;

    // ****************** these routes are only for visitors (non-signed in people) ********************** //
    return <Switch>
      <Redirect
        exact
        from="/"
        to="/signin"
      /> 

       {/* <RouteWithLayout 
        exact 
        path="/" 
        layout={HomeVisitor}
      //  component={HomeVisitor}
        updateUser={this.updateUser} apiManager={apiManager} appProps={appProps}
      />  */}
      <RouteWithLayout 
        exact 
        path="/signin" 
        layout={VisitorLayout}
        component={SignInView}
        // render={props => <SignInView {...props} />}
        updateUser={this.updateUser} apiManager={apiManager} appProps={appProps}
      />
    <RouteWithLayout 
        exact 
        path="/signout" 
        layout={VisitorLayout}
        component={SignInView}
        // render={props => <SignInView {...props} />}
        updateUser={this.updateUser} apiManager={apiManager} appProps={appProps}
      />
      <RouteWithLayout 
        exact 
        layout={VisitorLayout}
        component={SignUpView}
        path="/register"
        // render={props => <SignUpView {...props} updateUser={this.updateUser} apiManager={apiManager} appProps={appProps}/>}
        updateUser={this.updateUser} apiManager={apiManager} appProps={appProps}
      />
{/*    
            <Route 
        exact 
        path="/impersonate" 
        render={props => <ImpersonateView {...props} updateUser={this.updateUser} apiManager={apiManager} appProps={appProps}/>}

      /> */}
      <RouteWithLayout 
        exact 
        layout={MinimalLayout}
        component={TermsView}
        path="/terms-and-conditions" 
       // render={props => <TermsView {...props}  />}

      />
      {/* <RouteWithLayout 
        exact 
        layout={VisitorLayout}
        component={ResetView}
        path="/resetpassword" 
         updateUser={this.updateUser} apiManager={apiManager} appProps={appProps}
      /> */}
      <RouteWithLayout 
        exact 
        layout={VisitorLayout}
        component={ResetView}
        path="/forgotpassword" 
     //   render={props => <ResetView {...props} updateUser={this.updateUser} apiManager={apiManager} />}
        updateUser={this.updateUser} apiManager={apiManager} appProps={appProps}
      />
      <RouteWithLayout 
        exact 
        layout={VisitorLayout}
        component={SignUpVerification}
        path="/verification" 
        updateUser={this.updateUser} apiManager={apiManager} appProps={appProps}
      />
      <RouteWithLayout
        component={NotFoundView}
        exact
        layout={VisitorLayout}
        path="/page-not-found"
      />
      <RouteWithLayout
        component={ErrorView}
        exact
        layout={VisitorLayout}
        path="/error"
      />
      <Redirect to="/page-not-found" /> 
    </Switch>
  }
};

VisitorRoutes.propTypes = { 
  user: PropTypes.object, 
};

export default VisitorRoutes;
